import { render, staticRenderFns } from "./LeaveReportComponent.vue?vue&type=template&id=2a5188c8&"
import script from "./LeaveReportComponent.vue?vue&type=script&lang=js&"
export * from "./LeaveReportComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports